import { publishGa4Events } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import { useCitySelectedContext } from '@porterin/feature/src/contexts/city-context/CityContext';
import {
  GA_ESTIMATE_VERTICAL_SWITCH_ACTION,
  GA_ESTIMATE_VERTICAL_SWITCH_CATEGORY_ACTION,
} from '@porterin/feature/src/shared/core/constants/GAEventsConstants';
import React from 'react';

import styles from '../styles/CategorySelector.module.scss';

interface ChangeCategoryCmpProps {
  onChangeCategory: () => void;
  className?: string;
  currentCategory: string;
  category_name: string;
  change_label: string;
}

function ChangeCategoryCmp({
  onChangeCategory,
  className = '',
  currentCategory,
  category_name,
  change_label,
}: Readonly<ChangeCategoryCmpProps>): React.ReactElement {
  const citySelectedContext = useCitySelectedContext();

  return (
    <div className={`${styles['change-category-container']} ${className}`}>
      <div className={styles['current-category-text']}>{category_name}</div>
      <button
        className={styles['change-button']}
        onClick={() => {
          publishGa4Events(
            citySelectedContext.category,
            GA_ESTIMATE_VERTICAL_SWITCH_ACTION,
          );
          publishGa4Events(
            citySelectedContext.category,
            GA_ESTIMATE_VERTICAL_SWITCH_CATEGORY_ACTION + currentCategory,
          );
          onChangeCategory();
        }}
      >
        {change_label}
      </button>
    </div>
  );
}

export default ChangeCategoryCmp;
